import script from "./HrVersionedFormDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./HrVersionedFormDialog.vue?vue&type=script&setup=true&lang=js"

import "./HrVersionedFormDialog.vue?vue&type=style&index=0&id=282b4d27&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-282b4d27"]])

export default __exports__